import React, { useEffect, useState } from "react";
import { FxmsData } from "../datas/FxData";
import { FxInput0, FxInput } from "./FxInput";
import { FxAction } from "./../actions/FxAction";

/**
 * 그리드 상단위 검색 조건
 * 개발자 : T/F팀.
 * 개발년월 : 2022.11.
 * @param {*} props 
 * @returns 
 */

export const FxDataSearch = (props) => {
  let { selectedData, attrList, inputType } = props;
  const [inputDatas, setInputDatas] = React.useState({ ...selectedData });
  const [leftChild, setLeftChild] = React.useState([]);
  const [rightChild, setRightChild] = React.useState([]);
  const [uiAttrList, setUiAttrList] = React.useState([]);
  const [btnList, setBtnList] = React.useState([]);
  const newDatas = { ...selectedData };

  console.log("*** FxmsCRUDSearch ***", newDatas, inputDatas);

  useEffect(() => {
    const tmpObj = { ...selectedData };

    for (let attr of attrList) {
      if (attr.isButton() === false && tmpObj[attr.attrName] === undefined) {
        tmpObj[attr.attrName] = "";
        newDatas[attr.attrName] = "";
      }
    }
    setInputDatas(tmpObj);
    setUiAttrList(attrList);
  }, [attrList]);

  useEffect(() => {
    function getAttr(attrName) {
      for (let attr of uiAttrList) {
        if (attr.attrName === attrName) {
          return attr;
        }
      }
      return null;
    }

    function updateInputData(attrName, attrValue) {
      if (attrValue === null || attrValue === "") {
        delete newDatas[attrName];
      } else {
        newDatas[attrName] = attrValue;
      }

      setInputDatas({ ...newDatas });

      // 호출자에 함수가 정의되어 있으면 입력된 내용을 공유한다.
      if (props.onChangeDatas) {
        props.onChangeDatas(newDatas);
      }
    }

    const onChangeValue = (id, value) => {
      console.log("*** FxmsCRUD ***   onChangeValue : ", id, value);

      updateInputData(id, value);
      let attr = getAttr(id);
      if (attr.callback) {
        attr.callback(newDatas);
      }
      if (attr.onChange) {
        attr.onChange(newDatas);
      }

      // 입력된 값에 의해 SELECT박스의 옵션이 변경될 필요가 있을 때 처리한다.
      for (const attr of uiAttrList) {
        if (attr.isSelectBox() && attr.attrName != id) {
          if (attr.refreshItems) {
            attr.refreshItems(id, value);
          }
        }
      }
    };

    // 버튼 클릭했을 때 처리
    const clickButton = (event) => {
      const attr = getAttr(event.target.id);
      if (attr) {
        if (attr.onClick) {
          attr.onClick(newDatas);
        } else {
          const selectedRow = attr.datas.selectedRow;
          new FxAction(
            attr,
            newDatas,
            selectedRow ? selectedRow.id : undefined
          ).click();
        }
      }
    };

    //
    // 입력 컴포넌트 보이기
    //
    const leftChild = [];
    const rightChild = [];
    const bMap = new Map();
    function onButtonRef(attr, btnRef, resourceRef) {
      if (FxmsData.isDebug)
        console.log("*** FxmsCRUD ***   onButtonRef : ", attr.attrName);

      if (attr.isNeedData()) {
        const data = { attr: attr, btnRef: btnRef, resourceRef: resourceRef };
        bMap.set(data.attr.attrName, data);
        const tmpList = [];
        for (const d of bMap.values()) {
          tmpList.push(d);
        }
        setBtnList(tmpList);
      }
    }

    for (const attr of uiAttrList) {
      const node = FxInput0(
        attr,
        updateInputData,
        onChangeValue,
        clickButton,
        inputDatas,
        inputType,
        onButtonRef
      );

      if (attr.etcInfo === "right") {
        rightChild.push(node);
      } else {
        leftChild.push(node);
      }
    }

    setLeftChild(leftChild);
    setRightChild(rightChild);
  }, [uiAttrList]);

  useEffect(() => {
    // 상위노드가 버튼 목록을 받기를 원하면 제공한다.
    if (FxmsData.isDebug)
      console.log("*** FxmsCRUD ***   onButtonRef : ", btnList.length);
    if (props.onButtonRef) {
      props.onButtonRef(btnList);
    }
  }, [btnList]);

  return (
    <>
      <div className="FxFilterLeft">{leftChild}</div>
      <div className="FxFilterRight">{rightChild}</div>
    </>
  );
};
